import { motionService } from "../../services/motionService";

export interface MotionSlice {
  // Actions
  startMotionService: () => void;
  stopMotionService: () => void;
}

export const createMotionSlice = (set: any, get: any): MotionSlice => ({
  startMotionService: () => {
    const { updateCraneParameter } = get();
    motionService.onTick((deltaSeconds: number) => {
      const {
        speed,
        absTravel,
        boomSpeed = 0,
        slewSpeed = 0,
        boomAngle,
        boomMinAngle,
        boomMaxAngle,
        slewAngle,
        slewMinAngle,
        slewMaxAngle,
      } = get().craneParameters;
      if (speed !== 0) {
        const delta = (-speed / 50) * deltaSeconds; // units per second scaled by percent
        const nextTravel = Math.max(0, absTravel + delta);
        // Only update when values change to reduce renders
        if (nextTravel !== absTravel) {
          updateCraneParameter("absTravel", nextTravel);
          updateCraneParameter("relTravel", nextTravel);
        }
      }
      // Apply boom speed to boom angle over time
      if (boomSpeed !== 0) {
        const BOOM_DEG_PER_SEC_AT_100 = 10;
        const boomDelta =
          (boomSpeed / 100) * BOOM_DEG_PER_SEC_AT_100 * deltaSeconds;
        let nextBoom = boomAngle + boomDelta;
        nextBoom = Math.max(boomMinAngle, Math.min(boomMaxAngle, nextBoom));
        if (nextBoom !== boomAngle) {
          updateCraneParameter("boomAngle", nextBoom);
        }
      }
      // Apply slew speed to slew angle over time
      if (slewSpeed !== 0) {
        const SLEW_DEG_PER_SEC_AT_100 = 20;
        const slewDelta =
          (slewSpeed / 100) * SLEW_DEG_PER_SEC_AT_100 * deltaSeconds;
        let nextSlew = slewAngle + slewDelta;
        nextSlew = Math.max(slewMinAngle, Math.min(slewMaxAngle, nextSlew));
        if (nextSlew !== slewAngle) {
          updateCraneParameter("slewAngle", nextSlew);
        }
      }
    });
    motionService.enable();
  },
  stopMotionService: () => {
    motionService.disable();
  },
});
